<template>
  <div class="visualDrawer" v-if="drawerStatus">
    <div class="visualDrawerModule" :class="{ bounceInOpen: drawerStatus }" :style="drawerStyle">
      <div class="title indexJust">
        <p>{{ title }}</p>
        <div class="close" @click="close()"></div>
      </div>
      <div class="contentContainer">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      defalut: ''
    },
    drawerStyle: {}
  },
  data() {
    return {
      drawerStatus: false
    };
  },
  methods: {
    close(num) {
      this.drawerStatus = !!num;
    }
  }
};
</script>

<style lang="scss" scoped>
.visualDrawer,
.visualDrawerModule {
  width: 100%;
  height: 100%;
}
.visualDrawer {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 4500;
  box-sizing: border-box;
  padding: 5vw;
}
.visualDrawerModule {
  border: 1px solid #1d5fd1;
  // background: url("../../../../../static/img/visual/p-bg.svg") top center no-repeat;
  // background-size: ;
  .title {
    height: 2vw;
    background: linear-gradient(94deg, rgba(22, 95, 203, 0) 4%, #165fcb 56%, rgba(22, 95, 203, 0) 100%);
    font-size: 0.9vw;
    color: white;
    font-weight: bold;
    position: relative;
    .close {
      width: 1.2vw;
      height: 1.2vw;
      background: url('../../../static/img/visual/close.svg') top center no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }
  }
}
.contentContainer {
  width: 100%;
  height: calc(100% - 2vw);
  background: rgba(31, 43, 55, 0.9);
}

.indexJust {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/businessModule/drawer.vue